import { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain.ts'

import type { ProblemScoringViewOption } from '../(ProblemScoring)/@trait/ProblemScoringViewOption.trait'

type ViewOption = ProblemScoringViewOption<'학습모듈' | 'NOT_학습모듈'>

/**
 * 채점 결과 대시보드 노출 여부.
 * - 시험 응시 중 → 미노출 (응시 종료 후 노출)
 * - 시중교재(PUBLIC) · 교과서(SCHOOL) → 모든 status 미노출
 * - 그 외 → 노출
 */
export const showDashboard = (viewOption: ViewOption) => {
  if (viewOption.isExamInProgress) return false
  if (
    viewOption.content.kind === 'WORKBOOK' &&
    (viewOption.content.type === WorkbookDomain.TYPE.시중교재 ||
      viewOption.content.type === WorkbookDomain.TYPE.교과서)
  ) {
    return false
  }
  return true
}
